import React, { useState } from 'react';
import styles from './LoginPage.module.css';
import TopbarLogin from '../../components/TopbarLogin';
import { useNavigate } from 'react-router-dom';
const BACKEND_URL = process.env.REACT_APP_IAM_BACKEND_URL;

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const response = await fetch(`${BACKEND_URL}/iam/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();
      if (response.ok) {
        navigate('/surveys/upload');
      } else {
        setMessage(`❌ ${data.detail || 'Login failed'}`);
      }
    } catch (err) {
      setMessage('❌ Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <TopbarLogin />
      <div className={styles.body}>
        <div className={styles.container}>
          <h2 className={styles.title}>Login</h2>
          <form onSubmit={handleLogin}>
            <div className={styles.formGroup}>
              <label>Username</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div className={styles.formGroup}>
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit" disabled={loading}>
              {loading ? 'Logging in...' : 'Login'}
            </button>
            {loading && <div className={styles.spinner}></div>}
            {message && <p className={styles.message}>{message}</p>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
